// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.odlUn{align-items:center;display:flex;flex-direction:column;justify-content:center;padding:3rem 0}.vNoEP{color:var(--logo-loader-color,var(--anchore-color-brand-blue));width:5rem}@keyframes ZEOw3{to{stroke-dashoffset:0}}@keyframes IFIuL{to{stroke-dashoffset:-200}}.kqtQs{fill:none;stroke:currentcolor;stroke-dasharray:200;stroke-dashoffset:200;stroke-width:.7}.g3O8K{animation:IFIuL 3.2s ease-out infinite}.hPfpA{animation:ZEOw3 1.6s ease-in-out infinite alternate}.V8XKC{margin-top:1.5rem}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `odlUn`,
	"logo": `vNoEP`,
	"path": `kqtQs`,
	"repeat": `g3O8K`,
	"trace-repeat": `IFIuL`,
	"reverse": `hPfpA`,
	"trace": `ZEOw3`,
	"message": `V8XKC`
};
module.exports = ___CSS_LOADER_EXPORT___;
